import { render } from "./StructureCard.vue?vue&type=template&id=28d7fec4&scoped=true&ts=true"
import script from "./StructureCard.vue?vue&type=script&lang=ts"
export * from "./StructureCard.vue?vue&type=script&lang=ts"

import "./StructureCard.vue?vue&type=style&index=0&id=28d7fec4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d7fec4"]])

export default __exports__